<template>
    <div class="wrap">
        <div class="filters">
            <div class="filter filter--reset">
                <img src="/images/rates/close.svg" alt="" @click="clear_filter" />
                <span @click="clear_filter">Сбросить фильтры</span>
            </div>
            <div class="filter departments">
                <span @click="show_departmetns_list = true">Отделы</span>
                <img
                    @click="show_departmetns_list = true"
                    src="/images/rates/filters/departments_arrow_right.svg"
                    alt=""
                />
                <div class="departments_view" v-show="show_departmetns_list">
                    <!-- Тут будет всплывающее окно со списком всех отделов -->
                    <div class="departments_view__header">
                        <span @click="show_departmetns_list = false">Отдел</span>
                        <img
                            @click="show_departmetns_list = false"
                            src="/images/rates/filters/departments_arrow_down.svg"
                            alt=""
                        />
                    </div>
                    <div class="departments_view__list">
                        <a
                            href="#"
                            v-for="department in rates_by_rat"
                            :key="department._id"
                            @click="filter_rates_by_id(department.id)"
                        >
                            {{ department.name }}
                        </a>
                    </div>
                </div>
            </div>
            <div class="filter dates">
                <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="label" readonly v-bind="attrs" v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="dates" locale="ru-Ru" :first-day-of-week="1" range color="orange lighten-1"
                        ><v-btn text color="primary" @click="menu2 = false"> Отмена </v-btn
                        ><v-btn text color="primary" @click="save()"> Готово </v-btn></v-date-picker
                    >
                </v-menu>
            </div>
            <div class="filter sort" @click="change_select_type()">
                <span>{{ select.name }}</span>
                <img src="/images/rates/filters/sorts.svg" alt="" />
            </div>
        </div>

        <div class="d-flex justify-space-between">
            <div class="percents">
                <PercentAnt
                    v-for="index in 3"
                    :key="index"
                    :rate="filtered_rate.to_rates"
                    :rate_key="index"
                    @ant="on_ant"
                    :color="index == class_color ? true : false"
                />

                <div class="department-name">
                    <template v-if="my_role == 'orp' || my_role == 'admin'">
                        <a href="#" @click="select_dialog = true">
                            {{ filtered_rate.name }}
                            <img src="/images/rates/filters/departments_arrow_right.svg" />
                        </a>
                    </template>
                    <template v-else> {{ filtered_rate.name }} </template>
                </div>
            </div>

            <div class="comments">
                <Comment v-for="rate in filtered_rate.to_rates" :key="rate._id" :depart="rate" />
            </div>
        </div>
        <SelectDepartment
            v-if="my_role == 'orp' || my_role == 'admin'"
            :dialog="select_dialog"
            :rates="get_rates"
            @redirect="on_redirect"
            @close_modal="on_close_modal"
        ></SelectDepartment>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import PercentAnt from './PercentAnt.vue'
import Comment from './Comment.vue'
import SelectDepartment from './../modals/SelectDepartment.vue'

export default {
    name: 'ShowRatesById',
    data: () => ({
        select: { name: 'Сначала новые', type: 'new' },
        low: 0,
        middle: 0,
        high: 0,
        items: [
            { name: 'Сначала новые', type: 'new' },
            { name: 'Сначала старые', type: 'old' },
        ],
        label: 'Период',
        dates: [],
        class_color: '',
        out_dates: [],
        filter_department_id: null,
        filter_rate_for_department: null,
        date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
        menu2: false,
        show_departmetns_list: false,
        select_dialog: false,
        my_role: localStorage.getItem('title'),
    }),
    components: { PercentAnt, Comment, SelectDepartment },
    computed: {
        ...mapGetters(['get_rate', 'get_rates', 'get_rates_by_rate_id']),
        filtered_rate() {
            return this.get_rate(
                this.select.type,
                this.out_dates,
                this.filter_department_id,
                this.filter_rate_for_department
            )
        },

        rates_by_rat() {
            return this.get_rates_by_rate_id(this.$route.params.id)
        },
    },
    beforeMount() {
        this.load_rate(this.$route.params.id)
    },
    methods: {
        ...mapActions(['load_rate']),
        on_redirect(_id) {
            this.select_dialog = false
            location.href = `/rates/${_id}`
        },
        on_close_modal(value) {
            this.select_dialog = value
        },
        clear_filter() {
            this.select.type = 'new'
            this.out_dates = []
            this.filter_department_id = null
            this.filter_rate_for_department = null
            this.class_color = ''
        },
        on_ant(value) {
            this.class_color = value
            this.filter_rate_for_department = value
        },
        save() {
            this.label = ''
            this.dates.forEach((date, index) => {
                this.label +=
                    index != this.dates.length - 1
                        ? `${new Date(date).toLocaleDateString('ru-RU')} - `
                        : new Date(date).toLocaleDateString('ru-RU')
            })
            // this.label = this.dates.join('-')
            this.out_dates = this.dates
            this.menu2 = false
        },

        filter_rates_by_id(department_id) {
            this.filter_department_id = department_id
            this.show_departmetns_list = false
        },

        change_select_type() {
            this.select.type = this.select.type == 'new' ? 'old' : 'new'
            this.select.name = this.select.type == 'new' ? 'Сначала новые' : 'Сначала старые'
        },
    },
}
</script>

<style scoped>
.wrap {
    width: 1214px;
    margin: 0 auto;
}

.filters {
    display: flex;
    justify-content: space-between;
    height: 60px;
    margin-bottom: 30px;
}

.filters .filter {
    width: 296px;
    display: flex;
    align-items: center;
}

.filters .filter--reset {
    cursor: pointer;
}

.filters .filter--reset img {
    width: 10px;
    margin-right: 15px;
}

.filters .filter--reset span {
    font-size: 18px;
}

.filters .filter.departments,
.filters .filter.dates,
.filters .filter.sort {
    background: #ffffff;
    border-radius: 30px;
    padding: 16px 30px;
    font-size: 22px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    position: relative;
}

.filters .filter.departments .departments_view {
    width: 907px;
    z-index: 1000;
    background: #f5f5f5;
    border: 1px solid #ed7428;
    box-sizing: border-box;
    border-radius: 30px;
    position: absolute;
    top: 0;
    left: 0;
    padding: 17px 30px 50px;
}

.filters .filter.departments .departments_view .departments_view__header span {
    font-style: normal;
    font-weight: normal;
    font-size: 22px;
    line-height: 26px;
    color: #1f0303;
    margin-right: 135px;
}

.filters .filter.departments .departments_view .departments_view__list {
    display: flex;
    flex-wrap: wrap;
    margin-top: 40px;
}

.filters .filter.departments .departments_view .departments_view__list a {
    width: 266px;
    margin-bottom: 20px;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 130%;
    color: #1f0303;
    text-decoration: none;
}

.filters .filter.departments .departments_view .departments_view__list a:hover {
    text-decoration: underline;
}

.comments {
    width: 909px;
    max-height: 640px;
    overflow-y: auto;
}

.department-name {
    font-style: normal;
    font-weight: bold;
    font-size: 32px;
    line-height: 37px;
    color: #1f0303;
    margin-top: 20px;
}

.department-name a {
    font-style: normal;
    font-weight: bold;
    font-size: 32px;
    line-height: 37px;
    color: #1f0303;
    margin-top: 20px;
    text-decoration: none;
}

.department-name img {
    margin-left: 20px;
}
</style>